/*
 * FRENESI · Página do kit — o que muda quando o volume muda (15/10/2026).
 *
 * Mockup aprovado pelo dono: «Aprovado, qualquer modificação faremos
 * posteriormente.» O elemento <frenesi-kit-compra> (blocks/frenesi-kit-compra)
 * traz, num JSON, o preço do kit e o de cada perfume avulso em cada volume.
 * Ao trocar o volume, atualiza o que depende dele na página inteira:
 *
 *   [data-kit-economia]        a caixa «Economia» (some quando não há economia)
 *   [data-kit-economia-valor]  quanto o kit economiza
 *   [data-kit-separados]       quanto os perfumes custam separados
 *   [data-kit-ml]              «5 ml»
 *   [data-kit-avulso="ID"]     o avulso de cada perfume (seção «O kit por dentro»)
 *   [data-kit-resumo]          «3 decants de 5 ml · 15 ml no total · rendem…»
 *   [data-kit-frete]           a linha do frete grátis (blocks/frenesi-purchase-benefits)
 *
 * O primeiro estado vem pronto do Liquid; aqui só a troca de volume. O tema
 * troca o volume pelo variant-picker: o «change» do rádio e o «variant:update»
 * do tema chegam aqui, como em assets/frenesi-purchase-benefits.js.
 */
if (!customElements.get('frenesi-kit-compra')) {
  const brl = (centavos) => (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
  const normal = (v) => String(v || '').toLowerCase().replace(/\s+/g, '').replace('ml.', 'ml')

  customElements.define('frenesi-kit-compra', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort()
      this.controller = new AbortController()
      try {
        this.dados = JSON.parse(this.querySelector('script[data-frenesi-kit]')?.textContent || '{}')
      } catch {
        this.dados = {}
      }
      const signal = this.controller.signal
      const aoMudar = (event) => {
        if (event.target instanceof Element && event.target.closest('variant-picker')) this.atualizar()
      }
      document.addEventListener('change', aoMudar, { signal })
      document.addEventListener('variant:update', () => this.atualizar(), { signal })
    }

    disconnectedCallback() {
      this.controller?.abort()
    }

    /** No quick-add o kit vive dentro do diálogo; na página, o volume vem do seletor dela. */
    escopo() {
      return this.closest('quick-add-dialog, .quick-add-modal__content, .product-details, [data-product-grid-content]') || document
    }

    volume() {
      const picker = this.escopo().querySelector(`variant-picker[data-product-id="${this.dados.produto}"]`) || this.escopo().querySelector('variant-picker')
      for (const controle of picker ? picker.querySelectorAll('input[type="radio"]:checked, select') : []) {
        const v = normal(controle.value)
        if (this.dados.volumes?.[v]) return v
      }
      return null
    }

    escrever(seletor, texto) {
      for (const el of this.raiz().querySelectorAll(seletor)) if (el.textContent !== texto) el.textContent = texto
    }

    /** Fora do quick-add, a seção «O kit por dentro» fica fora do bloco: a página inteira. */
    raiz() {
      return this.closest('quick-add-dialog, .quick-add-modal__content') || document
    }

    atualizar() {
      const chave = this.volume()
      const v = chave ? this.dados.volumes[chave] : null
      if (!v) return
      const n = this.dados.n || 3

      this.escrever('[data-kit-ml]', `${v.ml} ml`)

      const economia = v.separados > 0 ? v.separados - v.kit : 0
      for (const caixa of this.raiz().querySelectorAll('[data-kit-economia]')) caixa.hidden = !(economia > 0)
      if (economia > 0) {
        this.escrever('[data-kit-economia-valor]', brl(economia))
        this.escrever('[data-kit-separados]', brl(v.separados))
      }

      for (const [id, preco] of Object.entries(v.avulsos || {})) this.escrever(`[data-kit-avulso="${id}"]`, brl(preco))

      if (v.de && v.ate) {
        this.escrever('[data-kit-resumo]', `${n} decants de ${v.ml} ml · ${v.ml * n} ml no total · rendem de ${v.de * n} a ${v.ate * n} borrifadas`)
      }

      const limiar = this.dados.frete || 0
      if (limiar > 0) {
        const gratis = v.kit >= limiar
        for (const linha of this.raiz().querySelectorAll('[data-kit-frete]')) linha.classList.toggle('is-ok', gratis)
        this.escrever('[data-kit-frete-titulo]', gratis ? 'Frete grátis neste volume' : `Faltam ${brl(limiar - v.kit)} para o frete grátis`)
        this.escrever('[data-kit-frete-sub]', gratis ? `Pedidos a partir de ${brl(limiar)} não pagam frete` : `O frete é por nossa conta a partir de ${brl(limiar)}`)
      }
    }
  })
}
